import { pushNotification } from 'redux/modules/alertnotifier';

const AXIOS = window._axios;

/**
 * Intercept all api calls to site backend and handle errors
 * @param {Object} store
 */
export function attachApiInterceptor(store) {
    if (AXIOS) {
        const onError = (response, err) => {
            let message = '';

            if (response) {
                const { status } = response;

                if (status >= 500) {
                    message = 'Une erreur est survenue, veuillez réessayer.';
                }
            }
            else if (err && err.code === 'ECONNABORTED') {
                message = 'Le serveur fonctionne actuellement à pleine capacité, veuillez réessayer.';
            }

            if (message) {
                store.dispatch(pushNotification({
                    type: 'danger',
                    headline: 'Erreur de serveur',
                    timeout: 3500,
                    message
                }));
            }
        };

        AXIOS.defaults.timeout = 15000;
        AXIOS.interceptors.response.use(
            (response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                }

                onError(response);

                const err = new Error(response.statusText);

                err.response = response;

                throw err;
            },
            (err) => {
                onError(err.response, err);

                return Promise.reject(err);
            }
        );
    }
}
